import DeleteOperationalModal from './DeleteOperationalModal.vue';

export default DeleteOperationalModal;
